import React from "react";
import { Link } from "react-router-dom";
import { colors, s } from "../lib/theme";

export default function LegalNotice() {
  return (
    <div style={{ ...s.page, maxWidth: 720 }}>
      <Link to="/" style={{ color: colors.textDim, fontSize: 13, fontWeight: 700, textDecoration: "none" }}>← Volver</Link>

      <h1 style={{ ...s.h1, marginTop: 16 }}>Aviso legal</h1>

      <div style={{ display: "flex", flexDirection: "column", gap: 20, marginTop: 20, color: colors.textDim, fontSize: 14.5, lineHeight: 1.7 }}>
        <section>
          <h2 style={sectionTitle}>Titular</h2>
          <p>
            Intec Engineering Solutions, S.L. — CIF B26602763<br />
            Domicilio social: [COMPLETAR]<br />
            Contacto: <a href="mailto:info@centineldx.com" style={{ color: colors.amber }}>info@centineldx.com</a>
          </p>
        </section>

        <section>
          <h2 style={sectionTitle}>Responsable del proyecto</h2>
          <p>Álvaro Céspedes Alves (EA1RFF)</p>
        </section>

        <section>
          <h2 style={sectionTitle}>Exención de responsabilidad</h2>
          <p>
            Centinel DX se ofrece "tal cual", sin garantías de disponibilidad continua, ausencia de
            errores o idoneidad para un fin concreto. Intec Engineering Solutions, S.L. no se hace
            responsable de la pérdida de datos, interrupciones del servicio, ni de las decisiones de
            puntuación o resultados de concursos derivadas del uso de la plataforma — la
            responsabilidad de verificar los resultados de cada actividad corresponde a su organizador.
            El uso de la aplicación no exime a los operadores de cumplir la normativa de radioaficionado
            vigente en su país.
          </p>
        </section>
      </div>
    </div>
  );
}

const sectionTitle = { fontSize: 12, fontWeight: 700, letterSpacing: "0.08em", color: colors.textFaint, marginBottom: 8, textTransform: "uppercase" };
